import { render, staticRenderFns } from "./contentLectureBook.vue?vue&type=template&id=301450f4&"
import script from "./contentLectureBook.vue?vue&type=script&lang=js&"
export * from "./contentLectureBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports